module.exports = __webpack_public_path__ + "img/RJC_LP_rjc@2x.a0336eb.webp";